<template>
  <div
    name="remote-control-tab"
    v-aha-emit-action.view="{ source }"
    class="remote-control-content text-center flex flex-col justify-center gap-4"
    :class="`items-${align}`"
  >
    <p>{{ $i18nPresenter.t('Present with notes, upcoming slides and audience Q&A.') }}</p>
    <aha-antd-button
      class="min-w-full"
      variant="primary"
      name="open-remote-control'"
      v-aha-emit-action="{ source }"
      @click="() => openLink()"
    >
      {{ $i18nPresenter.t('Start') }}
    </aha-antd-button>
    <div
      class="qr-code-wrapper flex flex-col justify-center gap-3 min-w-full"
      :class="`items-${align}`"
    >
      <div class="flex items-center min-w-full">
        <hr class="flex-grow border-t border-gray-40" />
        <span class="mx-2 tracking-wider">OR</span>
        <hr class="flex-grow border-t border-gray-40" />
      </div>
      <p>
        {{ $i18nPresenter.t('Open this on another device - no login needed.') }}
      </p>
      <QRCodeVue
        :qrCodeImageUrl="remoteLinkQrCode"
        :isLoading="isLoadingRemoteLink"
      />
    </div>
    <div
      class="remote-control-button-wrapper flex gap-2"
      :class="`justify-${align}`"
    >
      <aha-antd-button
        variant="secondary"
        icon-name="link-icon"
        icon-view-box="0 0 18 14"
        name="copy-remote-link"
        :aha-source="source"
        v-aha-click="copyLink"
      >
        {{ $i18nPresenter.t('Copy link') }}
      </aha-antd-button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import * as Sentry from '@sentry/vue'
import QRCodeVue from '@/components-v2/presentation-editor/editor-header/EditorHeaderPresentButton/QRCode.vue'
import Utils from '@/util'
import EventBus from '@/eventBus'

export default {
  components: {
    QRCodeVue,
  },
  props: {
    presentation: {
      type: Object,
      required: true,
    },
    source: {
      type: String,
      default: null,
    },
    align: {
      type: String,
      default: 'center',
    },
  },
  computed: {
    ...mapGetters('remoteControlLink', ['remoteLink', 'remoteLinkQrCode', 'isLoadingRemoteLink', 'remoteLinkCopySource']),
  },
  mounted() {
    if (!this.presentation) return
    this.getRemoteLink(this.presentation)
  },
  methods: {
    ...mapActions('remoteControlLink', ['getRemoteLink', 'resetRemoteLink']),
    copyLink() {
      try {
        navigator.clipboard.writeText(this.remoteLinkCopySource)
        Utils.showToastSuccess(this.$i18nPresenter.t('Link copied!'))
      } catch (error) {
        Sentry.captureMessage('navigator clipboard is not supported',
          {
            level: 'warning',
            tags: { component: 'remote-control-link' },
          })
      }
    },
    openLink() {
      EventBus.$emit('present-with-backstage')
    },
  },
}
</script>
